module.exports = __webpack_public_path__ + "static/media/great_place_work.388981bd.png";